<template>
  <div class="home">
    <Spinner :dark="true" :fullScreen="true" class="spinner" :class="{hidden: !computedLoading}"/>
    <template v-if="!computedLoading">
      <PanelsLayout/>
      <FlowChart/>
      <NodeDetail/>
      <LinkDetail/>
      <ValidationErrorsModal/>
      <SubscriptionStatusMessage/>
      <ModalCGU v-if="!CGUAccepted"/>
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import FlowChart from '@/components/FlowChart.vue'; 
import PanelsLayout from '@/components/Panels/PanelsLayout.vue';
import NodeDetail from '@/components/Details/NodeDetail.vue';
import LinkDetail from '@/components/Details/LinkDetailV2.vue';
import Spinner from '@/components/UIElements/Spinner.vue';
import API from '@/api/wrapper'
import { Block, ElementNode } from '@/types';
import { Watch } from 'vue-property-decorator';
import ValidationErrorsModal from '@/components/ValidationErrors/ValidationErrorsModal.vue'

import { APIBlockCategory, APIUser, APISocialAccount, APICluster, APICustomer } from '@/typesAPI';
import SubscriptionStatusMessage from '@/components/Subscription/SubscriptionStatusMessage.vue';
import ModalCGU from '@/components/Modals/ModalCGU.vue';

@Options({
  components: {
    FlowChart,
    PanelsLayout,
    Spinner,
    NodeDetail,
    LinkDetail,
    ValidationErrorsModal,
    SubscriptionStatusMessage,
    ModalCGU,
  },
})
export default class FlowView extends Vue {
  loadingIndex = true
  loadingCategories = true
  mounted(): void {
    this.$store.dispatch('projects/clearStore')
    API.user.getMe()
      .then((res:{user:APIUser, socialAccounts:APISocialAccount[], customers:APICustomer[]}) => {
        this.$store.dispatch('user/setUser', res.user)
        this.$store.dispatch('user/setCustomer', res.customers[0] ?? null)

        res.socialAccounts.forEach((socialAccount:APISocialAccount) => {
          this.$store.dispatch('user/setSocialAccount', {provider: socialAccount.attributes.provider, socialAccount: socialAccount})
        })
        this.$store.dispatch('errorsValidation/loadErrors')
        API.blocks.getCategories()
          .then(({blockCategories, definitions}) => {
            const blocks:Block[] = []
            blockCategories.forEach((blockCategory:APIBlockCategory) => {
              const block:Block = {
                ...blockCategory.attributes,
                id: blockCategory.id,
                preselectedFieldDefinitionId: blockCategory?.relationships.preselect_field_definition.data.id
              }
              blocks.push(block)
            })
            this.$store.dispatch('blocks/setBlockList', blocks)
            this.$store.dispatch('fields/addNodeFieldDefinitions', definitions)


            API.blocks.getIndex(this.$route.params.projectId as string)
            .then((result) => {
              this.$store.dispatch('blocksAPI/setBlockList', result.blocks)
              this.$store.dispatch('blocksAPI/setDeploymentList', result.deployments)
              this.$store.dispatch('elements/setNodesFromAPIBlocks', result.blocks)
              this.$store.dispatch('elements/setLinksFromAPIConnections', result.connections)
              this.$store.dispatch('fields/setFieldTabs', result.fieldsTabs)
            })
            .finally(() => {
              this.handleURL()
              this.loadingIndex = false
            })
          })
          .finally(() => {
            this.loadingCategories = false
          })
          
      })
      .catch(() => {
        this.$router.push({name: 'login'})
      })
  }

  get computedLoading(): boolean {
    return this.loadingIndex || this.loadingCategories
  }

  get CGUAccepted(): boolean {
    return this.$store.getters['user/getUser']?.attributes?.terms_of_use_accepted_at !== null
  }

  handleURL () {
    if(this.$route.params.blockId) {
      // Open Block
      this.$store.getters['elements/getNodes'].forEach((node:ElementNode) => {
        if(node.extra.blockAPIID === this.$route.params.blockId) {
          this.$store.dispatch('elements/setDetailOpenElement', node)
        }
      })
    }
  }

  @Watch('$route.params')
  onQueryChange() {
    this.handleURL()
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
  width: 100%;
  .spinner {
    transition: opacity 0.2s ease-in-out;
    opacity: 1;
    &.hidden {
      pointer-events: none;
      opacity: 0;
    }
  }
}
</style>
